import { Injectable } from '@angular/core';

import { registerLocaleData } from '@angular/common';

import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import localePt from '@angular/common/locales/pt';

registerLocaleData(localePt, 'pt');
registerLocaleData(localeEs, 'es');
registerLocaleData(localeEn, 'en');

@Injectable({
  providedIn: 'root'
})
export class LocaleService {

  language(): string {
    return navigator.language || navigator['userLanguage'] || 'pt-BR';
  }
}
